module.exports = __webpack_public_path__ + "static/media/all-funnysong.004ac20a.mp3";